module.exports = __webpack_public_path__ + "img/app2.f0b3f389.jpg";